import { useEffect } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import FooterSection from '@/pages/home/components/FooterSection';
import Breadcrumbs from '@/pages/Blog/components/Breadcrumbs';
import JsonLd, { breadcrumbSchema } from '@/components/base/JsonLd';
import useSeo, { SITE_URL, OG_IMAGE } from '@/hooks/useSeo';

export default function DisclaimerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useSeo({
    title: 'Disclaimer | TNT Coach AI',
    description: 'Important disclaimer for TNT Coach AI: an AI self-coaching and personal development tool, not a substitute for professional therapy, medical, legal, or financial advice.',
    canonical: `${SITE_URL}/disclaimer`,
    url: `${SITE_URL}/disclaimer`,
    image: OG_IMAGE,
  });

  return (
    <div className="min-h-screen bg-midnight">
      <JsonLd
        data={breadcrumbSchema([
          { name: 'Home', url: `${SITE_URL}/` },
          { name: 'Disclaimer', url: `${SITE_URL}/disclaimer` },
        ])}
      />
      <Navbar />
      <main>
        {/* Header */}
        <section className="pt-32 pb-16">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Disclaimer' }]} />
              <p className="text-champagne-gold text-sm font-medium tracking-wider uppercase mb-3">Legal</p>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-silver-grey mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Disclaimer
              </h1>
              <p className="text-silver-grey/60 text-sm">
                Last updated: June 29, 2026
              </p>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="border-t border-royal-navy/30" />
        </div>

        {/* Disclaimer Content */}
        <section className="py-12 md:py-16">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto space-y-10">
              <div>
                <h2 className="text-lg md:text-xl font-semibold text-champagne-gold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Disclaimer
                </h2>
                <p className="text-silver-grey/80 leading-relaxed text-sm md:text-base">
                  TNT Coach AI is a personal development and self-coaching tool. It is not therapy, medical advice, financial advice, legal advice, or a substitute for professional support. The app does not represent, imitate, or claim endorsement from any real coach, athlete, author, public figure, or organisation. Coaching styles are original and based on broad personal development principles.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Back link */}
        <section className="pb-16">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <a
                href="/"
                className="inline-flex items-center gap-2 text-champagne-gold hover:text-champagne-gold/80 transition-colors duration-300 text-sm"
              >
                <i className="ri-arrow-left-line" />
                Back to Home
              </a>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}